import React from 'react';
import { CpuIcon, ZapIcon, RadioIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const serviceCategories = [{
  titleKey: 'services.automation.title',
  Icon: CpuIcon,
  items: ['services.automation.item1', 'services.automation.item2', 'services.automation.item3', 'services.automation.item4', 'services.automation.item5', 'services.automation.item6', 'services.automation.item7']
}, {
  titleKey: 'services.electrical.title',
  Icon: ZapIcon,
  items: ['services.electrical.item1', 'services.electrical.item2', 'services.electrical.item3', 'services.electrical.item4', 'services.electrical.item5']
}, {
  titleKey: 'services.lowcurrent.title',
  Icon: RadioIcon,
  items: ['services.lowcurrent.item1', 'services.lowcurrent.item2', 'services.lowcurrent.item3', 'services.lowcurrent.item4', 'services.lowcurrent.item5']
}];
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="w-full bg-navy py-20 sm:py-28" data-id="element-260">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <ScrollFadeIn data-id="element-262">
          <div className="mb-4" data-id="element-263">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-264">
              {t('services.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-3" data-id="element-265">
            {t('services.heading')}
          </h2>
          <p className="text-slate-400 max-w-3xl mb-12" data-id="element-266">
            {t('services.subtitle')}
          </p>
        </ScrollFadeIn>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-267">
          {serviceCategories.map((cat, i) => <ScrollFadeIn key={cat.titleKey} delay={i * 100} data-id="element-268">
              <div className="h-full p-6 bg-graphite border border-slate-700/50 rounded flex flex-col" data-id="element-269">
                <div className="w-10 h-10 flex items-center justify-center rounded bg-electric/10 mb-4" data-id="element-270">
                  <cat.Icon className="w-5 h-5 text-electric" data-id="element-271" />
                </div>
                <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-5" data-id="element-272">
                  {t(cat.titleKey)}
                </h3>
                <ul className="space-y-2.5 flex-1" data-id="element-273">
                  {cat.items.map(itemKey => <li key={itemKey} className="flex items-start gap-2.5" data-id="element-274">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-electric shrink-0" data-id="element-275" />
                      <span className="text-xs text-slate-400 leading-relaxed" data-id="element-276">
                        {t(itemKey)}
                      </span>
                    </li>)}
                </ul>
              </div>
            </ScrollFadeIn>)}
        </div>
      </div>
    </section>;
}